import { priceFormat } from "./Price";

export function AdenaValue(props: { value: string | number }) {
  return <span style={{ color: "gold" }}>{priceFormat(props.value)}</span>;
}

export function AdenaColor() {
  return "gold";
}
